<template>
    <b-modal
        :visible="isOpen"
        :lazy="true"
        title-tag="h2"
        title="Delete Diagnosis"
    >
        <span>
            A deleted diagnosis will not be available for selection. Do you wish
            to delete this diagnosis?
        </span>

        <template v-slot:modal-footer>
            <div v-if="isLoading" class="preloader">
                <img src="assets/ajax-loader.gif" />
            </div>

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        reloadAfter: {
            type: Boolean
        }
    },
    data() {
        return {
            isLoading: false,
            isOpen: false,
            recordId: null
        };
    },
    methods: {
        close() {
            this.isOpen = false;
        },
        open(recordId) {
            this.isOpen = true;
            this.recordId = recordId;
        },
        async proceed() {
            try {
                this.isLoading = true;

                await this.$http.delete(
                    `${process.env.BARRAMUNDI}account/custom-diagnosis/${this.recordId}`,
                    {
                        data: {
                            status: 2 // 2 = Delete
                        }
                    }
                );

                // reload list
                if (this.reloadAfter) {
                    this.$emit("reloadlist");
                }

                this._message("Diagnosis deleted successfully");
                this.close();
            } catch (e) {
                this.isLoading = false;
                this._message("Error: Unable to delete", "danger");
            }
        }
    }
};
</script>

<style scoped>
.preloader {
    margin: 8px 0;
}
</style>
